import React from 'react'
import { congregationOptions } from 'constants/congregationOptions'
import { getCongregationDisplayLabel } from 'utils/congregationHelpers'
import { createColumn } from '../../../../utils/tableColumnHelpers'

export const makeCalculationsRowsCongregationCriteria = (congregationList) => {
  if (!Array.isArray(congregationList)) {
    return []
  }

  return congregationList.map((item) => {
    const congregationCriterias = Array.isArray(item.congregationCriterias)
      ? item.congregationCriterias
      : []

    return {
      speciesGroup: getCongregationDisplayLabel(item, congregationOptions),
      estimateBest: item.best === null ? '-' : item.best,
      ibaCriteria: congregationCriterias.length > 0 ? congregationCriterias.join(', ') : '-'
    }
  })
}



export const makeCalculationsColumnsCongregationCriteria = (canSeeIBACriteria) => {
  const baseColumns = [
    createColumn({
      id: 'speciesGroup',
      headerId: 'speciesGroup',
      accessorKey: 'speciesGroup'
    }),
    createColumn({
      id: 'estimateBest',
      headerId: 'estimateBest',
      accessorKey: 'estimateBest'
    })
  ]

  // Only add IBA criteria column if user has IBA access
  if (canSeeIBACriteria) {
    baseColumns.push(createColumn({
      id: 'ibaCriteria',
      headerId: 'ibaCriteria',
      accessorKey: 'ibaCriteria'
    }))
  }

  return baseColumns
}
